/* eslint-disable no-underscore-dangle */

import helpers from '../../js/helpers';

class Main {
	// ---------------------------------
	// ---------- CONSTRUCTOR ----------
	// ---------------------------------

	constructor(root) {
		this._root = root;
		this._elements = this._findElements();

		this._bindEventListeners();
	}

	// -----------------------------
	// ---------- METHODS ----------
	// -----------------------------

	// находит и возвращает элементы блока
	_findElements() {
		const r = this._root;

		return {
			title: r.querySelector('.main__title'),
			audio: r.querySelector('.main__audio'),
			text: r.querySelector('.main__text'),
			question: r.querySelector('.main__question'),
			flipCard: r.querySelector('.main__flip-card'),
			daub: r.querySelector('.main__daub'),
			picture: r.querySelector('.main__picture'),
		};
	}

	// регистрирует обработчики событий
	_bindEventListeners() {
		window.addEventListener('load', this._handleWindowLoad.bind(this));
	}

	// ------------------------------------
	// ---------- EVENT HANDLERS ----------
	// ------------------------------------

	_handleWindowLoad() {
		const {
			title,
			audio,
			text,
			question,
			flipCard,
			daub,
			picture,
		} = this._elements;

		setTimeout(() => {
			document.querySelector('.header').classList.remove('is-hide');
		}, 0);

		setTimeout(() => {
			title.classList.remove('is-hide');
		}, 500);

		setTimeout(() => {
			audio.classList.remove('is-hide');
		}, 1000);

		setTimeout(() => {
			flipCard.classList.remove('is-hide');
			daub.classList.remove('is-hide');
			picture.classList.remove('is-hide');
		}, 1500);

		setTimeout(() => {
			text.classList.remove('is-hide');
			question.classList.remove('is-hide');
			document.querySelector('.footer').classList.remove('is-hide');
		}, helpers.isMobile() ? 1500 : 2000);
	}
}

window.addEventListener('DOMContentLoaded', () => {
	// eslint-disable-next-line no-new
	new Main(document.querySelector('.main'));
});

